module.exports = __webpack_public_path__ + "img/clyq-6.03cf2a47.png";